import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const csrfToken = document.head.querySelector('meta[name="security-token"]');
        if (!csrfToken) {
            return next.handle(request);
        }

        const withCredentials = !request.url.startsWith(environment.endpointUrls.assignmentLink);
        const requestClone = request.clone({
            headers: withCredentials ? request.headers.set('X-CSRF-TOKEN', csrfToken.getAttribute('content')) : request.headers,
            withCredentials
        });

        return next.handle(requestClone);
    }
}
